import TSXComponent from '@/utils/tsx-component';
import Component from 'vue-class-component';
import { PageStatus } from '@/components/page-view';
import AdvertCarousel from '@/components/advert/carousel';
import { Form, Bottom, ActionBar, RadioGroup, Radio, Input, Card, Icon, Dialog, NoticeBar } from '@ohu-mobile/core';
import FormItem from '@/components/form-item';
import { ArrowRightSOutlined, ErrorWarningOutlined } from '@ohu-mobile/icons';
import { subjects } from '@/components/select/rank-select/RankSelect';
import SearchTip from '@/components/advert/search-tip';
import { Transcript } from './Transcript';
import { userModule } from '@/store/modules/user';
import { TrinityModule } from '../trinity.store';
import { optionalSubjects } from '@/utils/dictionary';
import { redirect } from '@/utils/page';
import { FloatingCard } from '@/components/floating-card';

@Component({ name: 'trinity-search' })
export class TrinitySearch extends TSXComponent {
  private transcriptVisible = false;
  public mounted() {
    this.$emit(PageStatus.SUCCESS);
    if (TrinityModule.shouldFilledIn && userModule.isLogin) {
      this.transcriptVisible = true;
    }

  }
  public viewSubjectGrade() {
    const content = this.grades.map((item, index) => {
      return `${subjects[index]}${item}`;
    }).join('/');
    Dialog.alert({ title: '学考科目等第', content, targetStyle: { height: '180px' } });
  }
  public submit(values: any) {
    this.$router.push({ path: 'result', append: true, query: Object.assign({
      awards: false,
    }, values) });
  }

  get grades() {
    const subjectGrade = userModule.trinityInfo?.subjectGrade;
    return subjectGrade ? subjectGrade.split('|') : [];
  }

  get subjects() {
    const optionalSubject = userModule.trinityInfo?.optionalSubject;
    return optionalSubject ? optionalSubject.split('|') : [];
  }

  get partailQuery() {
    return !userModule.allow('trinity:complete-query');
  }

  public render() {
    return (
      <div class="trinity-search">
        <AdvertCarousel
          areaCode="浙江"
          moduleCode="三位一体"
          showAreaCode="C8"
          random />
        <Transcript
          initValues={{
            subjectGrade: [...this.grades],
            optionalSubject: [...this.subjects],
          }}
          visible={this.transcriptVisible}
          onVisibleChange={(visible) => {
            this.transcriptVisible = visible
          }}
        />
        <Form inline={false}
          initialValues={{
            awards: undefined,
            academyName: '',
            professionName: '',
          }}
          validateSchema={(yup) => ({
            optionalSubject: yup.array().min(3, '请选择三个选考科目').max(3),
            subjectGrade: yup.array().min(10, '请选择学科等第').max(10),
            awards: yup.boolean().required('请选择是否获奖'),
          })}
          onSubmit={this.submit}
          scopedSlots={{
            default: () => {
              return (
                <div class="trinity-search__content">
                  <FloatingCard
                    class="trinity-search-transcript"
                    onClick={() => {
                      this.transcriptVisible = !this.transcriptVisible;
                    }}
                  >
                    {
                      TrinityModule.shouldFilledIn
                        ? <span>请填写三位一体成绩单</span>
                        : (
                          <div class="trinity-search-transcript__content">
                            <div class="trinity-search-transcript-item">
                              <div class="trinity-search-transcript-item__label">学考科目等第</div>
                              <div class="trinity-search-transcript-item__value">
                                {this.grades.join('/')}
                                <span class="question"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.viewSubjectGrade();
                                  }}>
                                  <Icon type={ErrorWarningOutlined} color="#0281FE" />
                                </span>
                              </div>
                            </div>
                            <div class="trinity-search-transcript-item">
                              <div class="trinity-search-transcript-item__label">选考科目</div>
                              <div class="trinity-search-transcript-item__value">
                                {this.subjects.map((s) => optionalSubjects[s]).join('/')}
                              </div>
                            </div>
                          </div>
                        )
                    }
                    <span><Icon type={ArrowRightSOutlined} /></span>
                  </FloatingCard>
                  {/* <div class="white-padding"></div>
                  <FormItem title="参加指定竞赛并获指定奖项" required tip="（必选）">
                    <Form.Field name="awards">
                      <RadioGroup class="trinity-search-awards">
                        <Radio value="1">是</Radio>
                        <Radio value="0">否</Radio>
                      </RadioGroup>
                    </Form.Field>
                  </FormItem> */}
                  <div class="white-padding"></div>
                  <FormItem title="请输入院校或专业" tip="（选填）" disabled={this.partailQuery}>
                    <Form.Field name="academyName">
                      <Input placeholder="请输入院校名称" allowClear />
                    </Form.Field>
                    <Form.Field name="professionName">
                      <Input placeholder="请输入专业名称" allowClear />
                    </Form.Field>
                  </FormItem>
                  {
                    this.partailQuery
                    &&
                    <NoticeBar
                      text="无法使用院校及专业名称进行筛选，点击升级"
                      action="link"
                      scrollable={false}
                      onClick={() => {
                        redirect('pay', { query: { type: 'SWYT' } });
                      }}  />
                  }
                  <SearchTip
                    areaCode="浙江"
                    moduleCode="三位一体"
                    showAreaCode="C33" />
                  <Bottom>
                    <ActionBar
                      actions={[
                        { text: '查 询', type: 'primary', htmlType: 'submit', disabled: TrinityModule.shouldFilledIn },
                      ]} />
                  </Bottom>
                </div>
              );
            },
          }} />
      </div>
    );
  }
}
